import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router';
import { BottomNav } from '../components/ui';
import { Av, Badge, Card, Group, IB, Ic, Row, Screen, Sm, Sp, Top } from '../components/p';
import { post } from '../lib/api';
import { useMe, useRegistrationInbox } from '../lib/queries';

/** ☰ More, as drawn (P39): the business side of the kitchen, away from the daily tabs. */
export function More() {
  const me = useMe().data;
  const owner = me?.user.role === 'owner';
  const waiting = useRegistrationInbox().data?.requests.length ?? 0;
  const qc = useQueryClient();
  const nav = useNavigate();
  const logout = async () => { await post('/auth/logout'); qc.clear(); nav('/welcome', { replace: true }); };

  return (
    <>
      <Screen>
        <Top><h1 className="p-h1">More</h1><Sp /><IB icon="close" label="Close" to="/" /></Top>
        <Card>
          <Row left={<Av name={me?.user.name ?? ''} dark />} t={me?.user.name ?? ''} s={`${owner ? 'Owner' : 'Staff'} · ${me?.kitchen.name ?? ''}`}
            right={(me?.kitchens.length ?? 0) > 1 ? <Sm label="Switch kitchen" to="/settings/team" /> : <Badge tone="g">{owner ? 'Owner' : 'Staff'}</Badge>} />
        </Card>
        <Group label="Business">
          <Card>
            {owner && <Row to="/revenue" left={<Ic text="₹" tone="g" />} t="Money" s="Collected, still due, payments and refunds" chev />}
            {owner && <Row to="/close-day" left={<Ic icon="check" />} t="Close the day" s="Cash, UPI and spending, then close the day" chev />}
            <Row to="/customers" left={<Ic icon="people" />} t="All customers" s="Plans and orders, one list" chev />
            <Row to="/registrations" left={<Ic icon="people" tone="s" />} t="Sign-ups" s="Your link and who’s waiting" right={waiting > 0 ? <Badge tone="s">{waiting} waiting</Badge> : undefined} chev={waiting === 0} />
          </Card>
        </Group>
        <Group label="Your kitchen">
          <Card>
            <Row to="/settings" left={<Ic icon="sliders" />} t="Settings" s="Kitchen, plans, delivery, payments, team" chev />
            <Row to="/import" left={<Ic icon="sheet" />} t="Import customers" s="From Excel or a list" chev />
            {me?.user.isTiffinifyTeam && <Row to="/admin" left={<Ic icon="sparkle" />} t="Tiffinify team" s="Kitchens, approvals and people" chev />}
          </Card>
        </Group>
        <div className="p-links"><button type="button" className="r" onClick={() => void logout()}>Sign out</button></div>
      </Screen>
      <BottomNav />
    </>
  );
}
